import axiosInstance from "../variables/api/axiosInstance";

export const searchProduction = async (searchValue) => {
    return await axiosInstance.get(`/api/contrat/search`, {
        params: {
            page: 0,
            size: 10,
            search: searchValue,
        },
    });
}

export const searchActiveProduction = async (searchValue) => {
    return await axiosInstance.get(`/api/contrat`, {
        params: {
            page: 0,
            size: 10,
            search: searchValue,
            avenant: "A"
        },
    });
}

export const searchSinistre = async (searchValue) => {
    return await axiosInstance.get(`/api/sinistre/sql`, {
        params: {
            page: 0,
            size: 10,
            search: searchValue,
        },
    });
}

export const searchUtilisateur = async (searchValue) => {
    return await axiosInstance.get(`/api/utilisateur`, {
        params: {
            page: 0,
            size: 10,
            search: searchValue,
        },
    });
}

export const searchAgenceByCompagnie = async (searchValue, codeCompagnie) => {
    return await axiosInstance.get(`/api/agence`, {
        params: {
            page: 0,
            size: 10,
            search: searchValue,
            organisme: codeCompagnie,
        },
    });
}

export const searchProfil = async (searchValue) => {
    return await axiosInstance.get(`/api/profil`, {
        params: {
            page: 0,
            size: 10,
            search: searchValue,
        },
    });
}

export const searchLotAttestation = async (searchValue) => {
    return await axiosInstance.get(`/api/lot-attestation/search`, {
        params: {
            search: parseInt(searchValue),
        },
    });
}

export const searchDecaissement = async (searchValue) => {
    return await axiosInstance.get(`/api/decaissement/search`, {
        params: {
            search: searchValue,
        },
    });
}

export const searchRoute = async (searchValue) => {
    return await axiosInstance.get(`/api/route`, {
        params: {
            search: searchValue,
        },
    });
}

export const searchCompte = async (searchValue) => {
    return await axiosInstance.get(`/api/compte-comptable`, {
        params: {
            search: parseInt(searchValue) || null,
        },
    });
}

export const searchAssure = async (searchValue) => {
    return await axiosInstance.get(`/api/personne/clients`, {
        params: {
            page: 0,
            size: 10,
            search: searchValue,
        },
    });
}













